import * as types from './redux.actionTypes';
import { DEFAULT_PAGE_SIZE } from './common';

const initialState = {
    templates: [],
    allGoals: [],
    departments: [],
    currentTemplate: null,
    currentTemplateGoals: [],
    loading: false,
    goalsLoading: false,
    pagination: {
        limit: DEFAULT_PAGE_SIZE,
        offset: 1,
        total: 0
    },
    filters: {
        search: ''
    },
    sort: {
        sortBy: 'createdAt',
        sortDescending: true
    },
    dialogs: {
        template: {
            open: false,
            data: null
        },
        goal: {
            open: false,
            data: null
        },
        manageGoals: {
            open: false,
            template: null
        },
        delete: {
            open: false,
            template: null
        },
        deleteGoal: {
            open: false,
            goalId: null
        }
    }
};

const kpiTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetch Templates
        case types.FETCH_TEMPLATES:
            return {
                ...state,
                loading: true
            };
        
        case types.FETCH_TEMPLATES_SUCCESS:
            return {
                ...state,
                loading: false,
                templates: action.payload.data,
                pagination: {
                    ...state.pagination,
                    total: action.payload.total
                }
            };
        
        case types.FETCH_TEMPLATES_FAILURE:
            return {
                ...state,
                loading: false
            };

        // Fetch Template with Goals
        case types.FETCH_TEMPLATE_WITH_GOALS:
            return {
                ...state,
                goalsLoading: true
            };
        
        case types.FETCH_TEMPLATE_WITH_GOALS_SUCCESS:
            // Update both currentTemplate and the template in the templates array
            const updatedTemplates = state.templates.map(template =>
                template.id === action.payload.id
                    ? { 
                        ...template, 
                        goals: action.payload.goals || action.payload.templateGoals || [],
                        goalsCount: (action.payload.goals || action.payload.templateGoals || []).length
                      }
                    : template
            );
            
            return {
                ...state,
                goalsLoading: false,
                currentTemplate: action.payload,
                currentTemplateGoals: action.payload.goals || action.payload.templateGoals || [],
                templates: updatedTemplates
            };
        
        case types.FETCH_TEMPLATE_WITH_GOALS_FAILURE:
            return {
                ...state,
                goalsLoading: false
            };

        // Create Template
        case types.CREATE_TEMPLATE:
            return {
                ...state,
                loading: true
            };
        
        case types.CREATE_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false
            };
        
        case types.CREATE_TEMPLATE_FAILURE:
            return {
                ...state,
                loading: false
            };

        // Update Template
        case types.UPDATE_TEMPLATE:
            return {
                ...state,
                loading: true
            };
        
        case types.UPDATE_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false
            };
        
        case types.UPDATE_TEMPLATE_FAILURE:
            return {
                ...state,
                loading: false
            };

        // Delete Template
        case types.DELETE_TEMPLATE:
            return {
                ...state,
                loading: true
            };
        
        case types.DELETE_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                templates: state.templates.filter(t => t.id !== action.payload)
            };
        
        case types.DELETE_TEMPLATE_FAILURE:
            return {
                ...state,
                loading: false
            };

        // Fetch All Goals
        case types.FETCH_ALL_GOALS:
            return {
                ...state,
                goalsLoading: true
            };
        
        case types.FETCH_ALL_GOALS_SUCCESS:
            return {
                ...state,
                goalsLoading: false,
                allGoals: action.payload
            };
        
        case types.FETCH_ALL_GOALS_FAILURE:
            return {
                ...state,
                goalsLoading: false
            };

        // Fetch Departments
        case types.FETCH_DEPARTMENTS:
            return {
                ...state
            };
        
        case types.FETCH_DEPARTMENTS_SUCCESS:
            return {
                ...state,
                departments: action.payload
            };
        
        case types.FETCH_DEPARTMENTS_FAILURE:
            return {
                ...state
            };

        // Goal Management
        case types.ADD_GOAL_TO_TEMPLATE:
        case types.UPDATE_TEMPLATE_GOAL:
        case types.REMOVE_GOAL_FROM_TEMPLATE:
            return {
                ...state,
                goalsLoading: true
            };
        
        case types.ADD_GOAL_TO_TEMPLATE_SUCCESS:
        case types.UPDATE_TEMPLATE_GOAL_SUCCESS:
        case types.REMOVE_GOAL_FROM_TEMPLATE_SUCCESS:
            return {
                ...state,
                goalsLoading: false
            };
        
        case types.ADD_GOAL_TO_TEMPLATE_FAILURE:
        case types.UPDATE_TEMPLATE_GOAL_FAILURE:
        case types.REMOVE_GOAL_FROM_TEMPLATE_FAILURE:
            return {
                ...state,
                goalsLoading: false
                // Do NOT clear currentTemplate or currentTemplateGoals on failure
            };

        // Template Dialog
        case types.OPEN_TEMPLATE_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    template: {
                        open: true,
                        data: action.payload
                    }
                }
            };
        
        case types.CLOSE_TEMPLATE_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    template: {
                        open: false,
                        data: null
                    }
                }
            };

        // Goal Dialog
        case types.OPEN_GOAL_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    goal: {
                        open: true,
                        data: action.payload
                    }
                }
            };
        
        case types.CLOSE_GOAL_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    goal: {
                        open: false,
                        data: null
                    }
                }
            };

        // Manage Goals Dialog
        case types.OPEN_MANAGE_GOALS_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    manageGoals: {
                        open: true,
                        template: action.payload
                    }
                }
            };
        
        case types.CLOSE_MANAGE_GOALS_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    manageGoals: {
                        open: false,
                        template: null
                    }
                },
                currentTemplate: null,
                currentTemplateGoals: []
            };

        // Delete Dialog
        case types.OPEN_DELETE_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    delete: {
                        open: true,
                        template: action.payload
                    }
                }
            };
        
        case types.CLOSE_DELETE_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    delete: {
                        open: false,
                        template: null
                    }
                }
            };

        // Delete Goal Dialog
        case types.OPEN_DELETE_GOAL_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteGoal: {
                        open: true,
                        goalId: action.payload
                    }
                }
            };
        
        case types.CLOSE_DELETE_GOAL_DIALOG:
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteGoal: {
                        open: false,
                        goalId: null
                    }
                }
            };

        // Filters and Pagination
        case types.SET_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };
        
        case types.SET_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };
        
        case types.SET_SORT:
            return {
                ...state,
                sort: {
                    ...state.sort,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};

export default kpiTemplateReducer;
